export default __webpack_public_path__ + "static/media/team_chief_avatar-01.7143ba60.png";